var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"slide-fade","tag":"div"}},_vm._l((_vm.notifications),function(notification){return _c('v-item',{key:notification.id,attrs:{"item":notification}})}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }